import React from 'react';
import UserListingList from 'src/components/adminUser/userListing/UserListingList';

const UserListing = () => (
  <UserListingList />
);

export default UserListing;
